"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _themeUi = require("theme-ui");

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

var _Group = require("../../Group");

var _VisualRadio = require("./VisualRadio");

var _TrueRadio = require("./TrueRadio");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/** @jsx jsx */
var Radio = _react.default.forwardRef(function (_a, ref) {
  var sx = _a.sx,
      _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      props = (0, _tslib.__rest)(_a, ["sx", "variant"]);
  return (0, _themeUi.jsx)(_Box.default, null, (0, _themeUi.jsx)(_TrueRadio.TrueRadio, (0, _tslib.__assign)({
    ref: ref,
    sx: sx
  }, props)), (0, _themeUi.jsx)(_VisualRadio.VisualRadio, {
    variant: variant,
    sx: sx
  }));
});

var RadioInput = _react.default.forwardRef(function (_a, ref) {
  var name = _a.name,
      props = (0, _tslib.__rest)(_a, ["name"]);
  var isInGroup = (0, _react.useContext)(_Group.GroupContext).inGroup;
  var inputName = isInGroup ? (0, _react.useContext)(_Group.GroupContext).name : name;
  return (0, _themeUi.jsx)(Radio, (0, _tslib.__assign)({
    ref: ref,
    name: inputName
  }, props));
});

RadioInput.displayName = 'RadioInput';
var _default = RadioInput;
exports.default = _default;